var _g, _g2, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFooterLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_13200",
    "data-name": "Group 13200",
    xmlns: "http://www.w3.org/2000/svg",
    width: 750,
    height: 208.149,
    viewBox: "0 0 750 208.149",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_13198",
    "data-name": "Group 13198",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_60974",
    "data-name": "Path 60974",
    d: "M109,105,7,207l137-69Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60975",
    "data-name": "Path 60975",
    d: "M7,208a.91.91,0,0,1,0-1L109,105a.91.91,0,0,1,1,0l34,33ZM109,106,10,205l133-67Z",
    fill: "#fff"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_13199",
    "data-name": "Group 13199",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_60976",
    "data-name": "Path 60976",
    d: "M1,1V208L106,102Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60977",
    "data-name": "Path 60977",
    d: "M1,208H0V1H1L107,102v1L1,208a.91.91,0,0,1-1,0ZM1,3V206L105,102Z",
    fill: "#fff"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_60978",
    "data-name": "Path 60978",
    d: "M6,1,148,136l62-32Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_60979",
    "data-name": "Path 60979",
    d: "M148,136h-1L6,1A.91.91,0,0,1,6,0L210,104a.91.91,0,0,1,0,1ZM9,3,148,135l61-31ZM343,131H282l-9,17c-3,5-6,8-11,8a10,10,0,0,1-10-10,15.35,15.35,0,0,1,2-7l40-76c6-11,12-13,18-13s12,2,18,13l40,76a16.76,16.76,0,0,1,3,7,10,10,0,0,1-10,10c-5,0-8-2-11-8Zm-51-19h41L312,73Zm123,33c0,7-4,11-10,11s-11-4-11-11V72c0-18,6-20,21-20h44c20,0,34,13,34,33,0,15-9,26-22,30l18,22c3,4,5,6,5,10,0,5-5,9-10,9-4,0-7-2-11-7l-25-31H415Zm42-74H418c-3,0-3,1-3,4V99h42c11,0,16-6,16-14S468,71,457,71Zm124,74c0,7-4,11-10,11s-11-4-11-11V110L515,68a10.67,10.67,0,0,1-4-7c0-7,5-10,11-10a10.86,10.86,0,0,1,7,3l42,38,41-38a10.86,10.86,0,0,1,7-3c6,0,11,3,11,10a10.67,10.67,0,0,1-4,7l-45,42Zm140-14H659l-8,17c-4,5-7,8-11,8a10,10,0,0,1-10-10,15.35,15.35,0,0,1,2-7l40-76c6-11,12-13,18-13s12,2,18,13l40,76a15.35,15.35,0,0,1,2,7,10,10,0,0,1-9,10c-5,0-8-2-12-8Zm-52-19h42L690,73Z",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterLogo);
export default __webpack_public_path__ + "static/media/footerLogo.c0bcb81666948257a3b382784d61d751.svg";
export { ForwardRef as ReactComponent };